import { NodeDetailsDto } from "domains/nodes/components/common/NodeDetailsDto";
import { Typography } from "@mui/material";
import localisation from "../../../../localisation";

interface IProps {
    nodeDetails: NodeDetailsDto;
}

const ReadOnlyNodeDetails = (props: IProps) => {
    const { nodeDetails } = props;

    const { nodeName, nodeReference, allowPartions } = localisation.nodeDetails.fields;

    const { readOnlyNodeDetails } = localisation.nodeDetails.components;

    return (
        <form aria-label={readOnlyNodeDetails}>
            <Typography variant="caption">{nodeName.labelText}</Typography>
            <Typography sx={{ pb: 1 }}>{nodeDetails.name}</Typography>

            <Typography variant="caption">{nodeReference.labelText}</Typography>
            <Typography sx={{ pb: 1 }}>{nodeDetails.reference}</Typography>

            <Typography variant="caption">{allowPartions.helperText}</Typography>
            <Typography sx={{ pb: 1 }}>{nodeDetails.allowPartitions === true ? allowPartions.yesText : allowPartions.noText}</Typography>
        </form>
    );
};

export default ReadOnlyNodeDetails;
